/**
 * Convert answer markdown to plain text suitable for SpeechSynthesis, so
 * the voice doesn't read punctuation/syntax aloud. Intentionally simple
 * (regex, no parser) — readback tolerates minor imperfections.
 */
export function markdownToSpeech(md: string): string {
  if (!md) return '';
  let s = md;
  s = s.replace(/```[\s\S]*?```/g, (m) => m.replace(/```/g, ''));   // fence markers
  s = s.replace(/`([^`]+)`/g, '$1');                                 // inline code
  s = s.replace(/!\[[^\]]*\]\([^)]*\)/g, '');                        // images
  s = s.replace(/\[([^\]]+)\]\([^)]*\)/g, '$1');                     // links -> text
  s = s.replace(/^#{1,6}\s+/gm, '');                                 // headings
  s = s.replace(/(\*\*|__)(.*?)\1/g, '$2');                          // bold
  s = s.replace(/(\*|_)(.*?)\1/g, '$2');                             // italic
  s = s.replace(/^\s*[-*+]\s+/gm, '');                               // list bullets
  s = s.replace(/^\s*\d+\.\s+/gm, '');                              // numbered lists
  s = s.replace(/^\s*>\s?/gm, '');                                   // blockquotes
  s = s.replace(/\|/g, ' ');                                         // table pipes
  s = s.replace(/\s+/g, ' ').trim();                                 // collapse ws
  return s;
}
